import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { defer, finalize } from 'rxjs';
import { RmsSpinnerService } from './rms-spinner.service';

/** For background polling or a request that must not block the screen. */
export const RMS_SKIP_SPINNER = new HttpContextToken<boolean>(() => false);

/**
 * Registered once in app.config.ts, this tracks HttpClient from ALL components
 * (including lazy pages and dialogs) without changing existing API methods.
 * Auth and other existing interceptors remain registered in their original order.
 */
export const rmsSpinnerInterceptor: HttpInterceptorFn = (request, next) => {
  const spinner = inject(RmsSpinnerService);
  if (request.context.get(RMS_SKIP_SPINNER)) return next(request);
  return defer(() => {
    const stop = spinner.begin('http', request.method === 'GET'
      ? 'Loading your workspace…'
      : 'Saving your changes…');
    return next(request).pipe(finalize(stop));
  });
};
